import { Component, EventEmitter, Input, OnInit, Output , signal } from '@angular/core';
import { MatFormField, MatOption, MatSelect, MatSelectTrigger } from '@angular/material/select';
import { ECar } from 'src/app/models/ecar';
import { AccountService } from 'src/app/services/account/account.service';
import { ConsoleLoggerService } from 'src/app/services/logging/console-logger.service';
import { VEHICLE_IMAGE_URL } from 'src/app/services/core/http.service';
import { SettingsService } from 'src/app/services/account/settings.service';
import { VehicleImageFallbackDirective } from 'src/app/directives/vehicle-image-fallback.directive';

/**
   * car selector for the user cars
   */
@Component({
  standalone: true,
  selector: 'app-user-vehicles-selector',
  imports: [MatOption, MatSelectTrigger, MatSelect, MatFormField, VehicleImageFallbackDirective],
  templateUrl: './user-vehicles-selector.component.html',
  styleUrls: ['./user-vehicles-selector.component.scss']
})
export class UserVehiclesSelectorComponent implements OnInit {

  @Input() newSubscription: boolean | null = null;
  @Input() historySelector: boolean | null = null;
  @Output() valueChange = new EventEmitter();
  public readonly userECars = signal<ECar[]>([]);
  public readonly selectedECar = signal<ECar | null>(null);

  readonly VEHICLE_IMAGE_URL = VEHICLE_IMAGE_URL;

  constructor(public accountService: AccountService, private consoleLoggerService: ConsoleLoggerService, public settingsService: SettingsService) { }

  ngOnInit(): void {
    let userCarsArray = this.accountService.getUserProfile().Ecars;
    this.userECars.set(userCarsArray);

    if (this.userECars().length > 0) {
      this.selectedECar.set(this.userECars()[0]);
    }

    // set active car as selected
    if (this.historySelector) {
      this.selectedECar.set(this.accountService.user.getSelectedUserCar());

      const lastSelectedVehicle = this.accountService.getHistoryLastSelectedVehicle();
      if (lastSelectedVehicle) {
        this.selectedECar.set(lastSelectedVehicle);
        this.accountService.setHistoryLastSelectedVehicle(null);
      }
    }

    this.valueChange.emit(this.selectedECar());
  }

  public selectionChanged(): void {
    this.valueChange.emit(this.selectedECar());
  }
}
